module.exports = __webpack_public_path__ + "img/iconright.e92b45af.png";